import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import { CALL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import HubSpotAppLink from 'crm-links/common/components/HubSpotAppLink';
import { jsx as _jsx } from "react/jsx-runtime";
const CallHighlightActions = ({
  objectId
}) => {
  const portalId = PortalIdParser.get();
  const getItems = () => {
    const items = [{
      Component: /*#__PURE__*/_jsx(HubSpotAppLink, {
        linkType: "CRM_OBJECT_RECORD_ALL_PROPERTIES",
        linkTypeProps: {
          includeEschref: true,
          objectTypeId: CALL_TYPE_ID,
          objectId
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "call-highlight-card.actions.viewAllProperties"
        })
      })
    }, {
      key: 'call-highlight-card.actions.viewPropertyHistory',
      href: `/contacts/${portalId}/record/0-48/${objectId}/history`
    }, {
      key: 'actions-divider-0',
      isDivider: true
    }, {
      key: 'call-highlight-card.actions.viewAssociationHistory',
      href: `/association-history/${portalId}/0-48/${objectId}?external=true`
    }];
    return items;
  };
  const renderItems = () => {
    const items = getItems();
    return items.map(item => {
      const {
        key,
        href,
        isDivider,
        Component
      } = item;
      if (Component) {
        return Component;
      }
      if (isDivider) {
        return /*#__PURE__*/_jsx(UIDropdownDivider, {}, key);
      }
      return /*#__PURE__*/_jsx(UIButton, {
        href: href,
        use: "link",
        "data-selenium-test": `call-highlight-card-actions-${key}`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: key
        })
      }, key);
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: "text-right p-right-6 p-top-6 p-bottom-6",
    children: /*#__PURE__*/_jsx(UIDropdown, {
      buttonUse: "link",
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "call-highlight-card.actions.title"
      }),
      children: /*#__PURE__*/_jsx(UIList, {
        children: renderItems()
      })
    })
  });
};
export default CallHighlightActions;